import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Polyfills for Solana Web3.js
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
globalThis.process = { env: {} };

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
